<template>
  <Navbar v-if="hasBreadcrumb" class="navbar has-shadow" style="z-index: 0">
    <template #start>
      <Breadcrumb v-if="isReady">
        <BreadcrumbItem
          v-for="({ to, label }, index) in items"
          :key="index"
          :to="to"
          :active="index + 1 === items.length"
        >{{ $t(label) }}</BreadcrumbItem>
      </Breadcrumb>
    </template>
  </Navbar>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";

import { findRouteByName } from "@/utils/breadcrumb.js";

export default {
  components: {
    Navbar,
    Breadcrumb,
    BreadcrumbItem
  },
  data() {
    return {
      isReady: false,
      document: null
    };
  },
  computed: {
    hasBreadcrumb() {
      // FIXME: move to config
      return !["Home"].includes(this.$route.name);
    },
    isDataRequired() {
      return this.documentId !== null && this.document === null;
    },
    path() {
      return findRouteByName(routes, this.$route.name);
    },
    items() {
      return this.path.map(item => this.create(item));
    },
    documentId() {
      return this.$route.params["documentId"] || null;
    }
  },
  async mounted() {
    try {
      await this.load();
    } catch (err) {
      console.error(err);
    }
  },
  deactivated() {
    this.isReady = false;
  },
  destroyed() {
    this.isReady = false;
  },
  methods: {
    async load() {
      if (!this.isDataRequired) {
        this.isReady = true;
      } else {
        this.document = await this.api.fetchDocument(this.documentId);
        this.$nextTick(() => (this.isReady = true));
      }
    },
    create(item) {
      return {
        to: this.createLink(item),
        label: this.createLabel(item)
      };
    },
    createLink({ name, paramNames = [] }) {
      return {
        name: name,
        params: this.getResolvedParams(paramNames)
      };
    },
    createLabel({ name, paramNames = [], label }) {
      const params = this.getResolvedParams(paramNames);
      return typeof label === "function"
        ? label(this.getResolvedParamValues(params))
        : label;
    },
    getResolvedParams(paramNames) {
      return paramNames.reduce(
        (obj, name) => ({
          ...obj,
          [name]: this.$route.params[name]
        }),
        {}
      );
    },
    getResolvedParamValues(params) {
      const results = {};

      for (const key in params) {
        if ("documentId" === key) {
          // NOTE: assuming non-normalized thing
          results["document"] = this.document;
        } else {
          results[key] = params[key];
        }
      }

      return results;
    }
  }
};

// TODO: build this from router.js
const routes = {
  name: "Home",
  label: "Home",
  children: [
    {
      name: "About",
      label: "About"
    },
    {
      name: "Imprint",
      label: "Imprint"
    },
    {
      name: "Privacy",
      label: "Privacy"
    },
    {
      name: "Search",
      label: "Search"
    },
    {
      name: "StaticDirectory",
      label: "Browse"
    },
    // {
    //   name: "Directory",
    //   label: "Directory",
    //   children: [
    //     {
    //       name: "Document",
    //       label: ({ document }) => document.title || "",
    //       paramNames: ["documentId"],
    //       children: [
    //         {
    //           name: "PageDetail",
    //           label: ({ pageNum }) => `Page ${pageNum}`,
    //           paramNames: ["documentId", "pageNum"]
    //         }
    //       ]
    //     }
    //   ]
    // }
  ]
};
</script>
